"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useConfiguration = exports.configurationContextDefaultValues = exports.configurationContext = exports.ConfigurationProvider = void 0;
var _react = require("react");
var _models = require("../models");
/* istanbul ignore file */

const configurationContextDefaultValues = exports.configurationContextDefaultValues = {
  currentLanguage: '',
  tenant: '',
  translations: _models.TranslationKey
};
const configurationContext = exports.configurationContext = /*#__PURE__*/(0, _react.createContext)(configurationContextDefaultValues);
const ConfigurationProvider = exports.ConfigurationProvider = configurationContext.Provider;
const useConfiguration = () => (0, _react.useContext)(configurationContext);
exports.useConfiguration = useConfiguration;
